import React, { useState } from 'react'
import { getLinkPathname } from '../helper'
import chevron from '../../../images/chevron-down.svg'
import { Link } from '../../global'

import '../navigation.scss'
import './mobileLinks.scss'

/**
 * Represents a mobile navigation link component with optional sub-menu.
 *
 * @param {Array} props.subMenu - An array of sub-menu items.
 * @param {string} props.label - The label or text for the link.
 * @param {string} props.url - The URL to navigate to.
 * @returns {JSX.Element} A React component for the mobile navigation link.
 */
export const MobileLinks = ({ subMenu, label, url }) => {
  const [open, setOpen] = useState(false)
  const pathname = typeof window !== 'undefined' && window.location.pathname

  const linkPathname = getLinkPathname({ url })
  const isActive = pathname.includes(linkPathname)

  !open && isActive && setOpen(true) // Går inte å stänga denna xD

  return (
    <div className="menu-item">
      {(subMenu?.length && (
        <>
          <button className="icon-button" onClick={() => setOpen(!open)}>
            <p
              className={`nav__ul-item nav-link${
                ((isActive || open) && '__active') || ''
              }`}
            >
              {label}
            </p>
            {!isActive && (
              <img
                className={`${(open && 'active__img') || ''}`}
                src={chevron}
                alt=""
              />
            )}
          </button>

          {open && (
            <div className={`sub-menu`}>
              {subMenu.map((item, index) => {
                const isActive = getLinkPathname(item) === pathname
                return (
                  <Link
                    key={index}
                    className={`nav__ul-item nav-link${
                      (isActive && '__active') || ''
                    }`}
                    to={item.path}
                  >
                    {item.label}
                  </Link>
                )
              })}
            </div>
          )}
        </>
      )) || (
        <Link
          className={`nav__ul-item nav-link${(isActive && '__active') || ''}`}
          to={url}
        >
          {label}
        </Link>
      )}
    </div>
  )
}
